<template>
  <label class="slider-checkbox">
    <input
      type="checkbox"
      :checked="value"
      @change="$emit('input', $event.target.checked)"
    />
    <span class="slider rounded-full" :class="{ 'slider-checked': value }">
      <span class="slider-circle"></span>
    </span>
  </label>
</template>

<script>
export default {
  name: 'SliderCheckbox',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.slider-checkbox {
  position: relative;
  display: inline-block;
  width: 2.5rem;
  height: 1.5rem;
}

.slider-checkbox input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ccc;
  transition: .4s;
}

.slider-circle {
  position: absolute;
  content: "";
  height: 1rem;
  width: 1rem;
  left: 0.25rem;
  bottom: 0.25rem;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #4D84FF;
}

input:focus + .slider {
  box-shadow: 0 0 1px #4D84FF;
}

input:checked + .slider .slider-circle {
  transform: translateX(1rem);
}

/* Improve accessibility */
.slider-checkbox input:focus-visible + .slider {
  outline: 2px solid #4A90E2;
  outline-offset: 2px;
}
</style>